module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app-wrapper"
  }, [_c('navbar'), _vm._v(" "), _c('sidebar', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.sidebar.isShow),
      expression: "sidebar.isShow"
    }],
    staticClass: "sidebar-container"
  }), _vm._v(" "), _c('div', {
    class: _vm.sidebar.isShow ? 'main-container-showSideBar' : 'main-container',
    attrs: {
      "id": "main-container"
    }
  }, [_c('app-main')], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-74167e05","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/Layout.vue
// module id = 290
// module chunks = 48